module.exports = __webpack_public_path__ + "static/img/declaration-right-active.95107e57.svg";